import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import enTranslations from '../assets/i18n/en.json';
import zhTranslations from '../assets/i18n/zh.json';
// Get translations based on language
var getTranslations = function (lang) {
    switch (lang) {
        case 'en':
            return enTranslations;
        case 'zh':
            return zhTranslations;
        default:
            return enTranslations;
    }
};
// Create context with default values
export var LanguageContext = createContext({
    language: 'en',
    setLanguage: function () { },
    translations: enTranslations,
    t: function (key) { return key; },
    isFirstRun: true,
    setIsFirstRun: function () { },
});
// Provider component
export var LanguageProvider = function (_a) {
    var children = _a.children;
    // Get language from localStorage or use default
    var _b = useLocalStorage('language', 'en'), language = _b[0], setLanguage = _b[1];
    var _c = useState(getTranslations(language)), translations = _c[0], setTranslations = _c[1];
    var _d = useLocalStorage('isFirstRun', true), isFirstRun = _d[0], setIsFirstRun = _d[1];
    // Update translations when language changes
    useEffect(function () {
        setTranslations(getTranslations(language));
    }, [language]);
    // Translation function
    var t = function (key) {
        return translations[key] || key;
    };
    // Context value
    var value = {
        language: language,
        setLanguage: setLanguage,
        translations: translations,
        t: t,
        isFirstRun: isFirstRun,
        setIsFirstRun: setIsFirstRun,
    };
    return (_jsx(LanguageContext.Provider, { value: value, children: children }));
};
